import { useQuery } from '@tanstack/react-query';
import API from '../../../../utils/api';

/**
 * Hook para obtener la configuración de OrkestaPay (merchant_id, public_key, is_sandbox, etc.)
 * @returns {UseQueryResult} Resultado de useQuery con data, isLoading, error, refetch, etc.
 *
 * @returns {Object} Objeto con la configuración de OrkestaPay
 */
export function useOrkestaConfig(options = {}) {
  return useQuery(
   ['orkestaPay', 'config'],
    async () => {
      const { data } = await API.orkestaGetConfig();
      return data?.data ?? data;
    },
    {
      staleTime: 5 * 60 * 1000, // 5 min - la config no cambia seguido
      ...options,
    }
  );
}
